import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { MoonLoader } from "react-spinners";
import { APIConstants } from "../../utils/api/constants";
import { APIState } from "../../utils/api/reducer";
import { useQueryParams } from "../../utils/queryParams";
import { setSideOne, setSideTwo } from "../store/actions";
import { Player, SelectedPlayers } from "../store/types";
import PlayerInput from "./PlayerInput";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: "24px 0",
      justifyContent: "center",
      alignItems: "center",
    },
    vs: {
      color: theme.palette.common.white,
      justifyContent: "center",
      display: "flex",
      fontWeight: 700,
      fontSize: 44,
      fontFamily: "Roboto",
      fontStyle: "normal",
    },
    loader: {
      color: "white",
      marginTop: 8,
      fontFamily: "Roboto",
      "& span": {
        borderColor: "white !important",
      },
    },
  })
);

interface ReduxProps {
  readonly players: APIState<Player[]>;
  readonly selectedPlayers: SelectedPlayers;
}

interface DispatchProps {
  readonly SetSideOne: (players: string[]) => void;
  readonly SetSideTwo: (players: string[]) => void;
}

type Props = ReduxProps & DispatchProps;

const PlayerInputs = (props: Props) => {
  const classes = useStyles();
  const { players, selectedPlayers, SetSideOne, SetSideTwo } = props;
  const [playerList, SetPlayerList] = React.useState<Player[]>([]);
  const [side1Preloaded, SetSide1Preloaded] = React.useState<string[]>([]);
  const [side2Preloaded, SetSide2Preloaded] = React.useState<string[]>([]);
  let queryParams = useQueryParams();

  const handleSelect = (side: string, player: string, prevPlayer: string) => {
    const side1 = selectedPlayers.side1;
    const playerExistsSide1 = side1.find((p) => p === player);
    !playerExistsSide1 && side === "one" && side1.push(player);
    const side1Filtered = side1.filter((p) => p !== prevPlayer);

    const side2 = selectedPlayers.side2;
    const playerExistsSide2 = side2.find((p) => p === player);
    !playerExistsSide2 && side === "two" && side2.push(player);
    const side2Filtered = side2.filter((p) => p !== prevPlayer);

    if (side === "one") {
      SetSideOne(side1Filtered);
    } else {
      SetSideTwo(side2Filtered);
    }
  };

  const removePlayer = (side: string, player: string) => {
    const side1 = selectedPlayers.side1;
    const side2 = selectedPlayers.side2;
    const side1Filtered = side1.filter((p) => p !== player);
    const side2Filtered = side2.filter((p) => p !== player);

    if (side === "one") {
      SetSideOne(side1Filtered);
      const preloaded = side1Preloaded;
      const playerIndex = preloaded.findIndex((s) => s === player);
      preloaded[playerIndex] = "";
      SetSide1Preloaded(preloaded);
    } else {
      SetSideTwo(side2Filtered);
      const preloaded = side2Preloaded;
      const playerIndex = preloaded.findIndex((s) => s === player);
      preloaded[playerIndex] = "";
      SetSide2Preloaded(preloaded);
    }
  };

  React.useEffect(() => {
    SetPlayerList(players.data || []);
  }, [players]);

  React.useEffect(() => {
    const side1 = (queryParams.get("side1") || "").split("+");
    const side2 = (queryParams.get("side2") || "").split("+");

    SetSide1Preloaded(side1);
    SetSide2Preloaded(side2);
  }, []);

  return (
    <Grid container className={classes.root}>
      {players.status === APIConstants.STARTED && (
        <MoonLoader className={classes.loader} />
      )}
      {players.status === APIConstants.SUCCEEDED && playerList.length > 0 && (
        <>
          <Grid item xs={12} sm={4} lg={3}>
            <PlayerInput
              players={players.data}
              setPlayer={(player: string, prevPlayer: string) =>
                handleSelect("one", player, prevPlayer)
              }
              removePlayer={(player: string) => removePlayer("one", player)}
              loadedPlayer={side1Preloaded[0]}
              unfilteredPlayers={players.data}
            />
            <PlayerInput
              players={playerList}
              setPlayer={(player: string, prevPlayer: string) =>
                handleSelect("one", player, prevPlayer)
              }
              removePlayer={(player: string) => removePlayer("one", player)}
              loadedPlayer={side1Preloaded[1]}
              unfilteredPlayers={players.data}
            />
          </Grid>
          <Grid item xs={1} className={classes.vs}>
            vs
          </Grid>
          <Grid item xs={12} sm={4} lg={3}>
            <PlayerInput
              players={playerList}
              setPlayer={(player: string, prevPlayer: string) =>
                handleSelect("two", player, prevPlayer)
              }
              removePlayer={(player: string) => removePlayer("two", player)}
              loadedPlayer={side2Preloaded[0]}
              unfilteredPlayers={players.data}
            />
            <PlayerInput
              players={playerList}
              setPlayer={(player: string, prevPlayer: string) =>
                handleSelect("two", player, prevPlayer)
              }
              removePlayer={(player: string) => removePlayer("two", player)}
              loadedPlayer={side2Preloaded[1]}
              unfilteredPlayers={players.data}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

const mapStateToProps = (state: any) => {
  const { players, selectedPlayers } = state.playerCompare;
  return {
    players,
    selectedPlayers,
  };
};

const mapDispatchToProps = {
  SetSideOne: setSideOne,
  SetSideTwo: setSideTwo,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayerInputs);
